import React, { useEffect, useState } from "react";
import "./Accounting.scss";
import { useSelector, useDispatch } from "react-redux";
import { getCoAAllWatched } from "../../util/API/accounting";
import AccountingTable from "../../components/AccountingTable/AccountingTable";
import PostEntryModal from "../../components/PostEntryModal/PostEntryModal";
import {
  setAccountList,
  setAccountListFilter,
} from "../../store/redux/accountingTable";
import CSVImage from "../../images/csv-file.png";
import { CSVLink } from "react-csv";

function Accounting() {
  const [accountType, setAccountType] = useState("All");
  const [open, setOpen] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [loadingData, setLoadingData] = useState(true);
  const [currency, setCurrency] = useState("All");
  const dispatch = useDispatch();

  //const accountData = useSelector((state) => state.accountList.accounts);
  const handleClose = () => setOpen(false);
  const handleOpen = (transaction) => {
    setOpen(true);
  };

  const accountingDataState = useSelector(
    (state) => state.accountingTable.accountingTable
  );

  const accountingDataStateFilter = useSelector(
    (state) => state.accountingTable.accountingTableFilter
  );

  //Get the accounting data and set it to the redux state for the accounting table
  useEffect(() => {
    async function fetchgetCoAAllWatched() {
      let accountingData = await getCoAAllWatched("1/UXP");
      dispatch(setAccountList({ accountingData: accountingData.data.record }));
      dispatch(
        setAccountListFilter({ filterAccountData: accountingData.data.record })
      );

      setLoadingData(false);
    }

    fetchgetCoAAllWatched();
  }, []);

  //Printing a CSV is done below
  // Add your title here
  const titleRow = [`Charts of Accounts`];

  const csvData = [
    // Add the title row as the first row
    titleRow,
    // Add an empty row to separate the title from the header
    [],
    // These will be header columns
    ["Account Type", "Account ID", "Account Name", "Debit", "Credit"],
    ...(accountingDataStateFilter && Array.isArray(accountingDataStateFilter)
      ? accountingDataStateFilter.map((row) => [
          row.vacctstructure.accttypename,
          row.vacctstructure.acctID,
          row.vacctstructure.firstName + " " + row.vacctstructure.lastName,
          parseInt(row.vacctstructure.balance) > 0
            ? row.vacctstructure.balance
            : "-",
          parseInt(row.vacctstructure.balance) < 0
            ? Math.abs(parseInt(row.vacctstructure.balance) * -1)
            : "-",
        ])
      : []),
  ];

  //Handle currency changes
  const handleCurrencyChange = async (e) => {
    setLoadingData(true);
    //If the accounts previously has a type, it will just set it to All once you change currencies
    setAccountType("All");
    let queryParam = "1/" + (e.target.value ? e.target.value : "UXP");
    const accountingData = await getCoAAllWatched(queryParam);
    dispatch(
      setAccountListFilter({ filterAccountData: accountingData.data.record })
    );
    setLoadingData(false);
  };

  // Handle Account type changes
  const handleAccountType = async (e) => {
    let value = e.target.value;
    setAccountType(value);

    //Filter the account types
    let filteredAccountTypes = accountingDataState.filter((data) => {
      return data.vacctstructure.accttypename == value;
    });

    if (value == "All") {
      dispatch(
        setAccountListFilter({ filterAccountData: accountingDataState })
      );
    } else {
      dispatch(
        setAccountListFilter({ filterAccountData: filteredAccountTypes })
      );
    }
  };

  return (
    <>
      <PostEntryModal open={open} handleClose={handleClose} />
      <div className="page-container roles-container  accounting-container">
        <div className="header-container">
          <div className="page-title">Accounting</div>
        </div>

        <div className="transaction-history">
          {/* <div className="d-flex justify-content-end mb-2"></div> */}
          <div className="d-flex justify-content-between">
            <p className="transaction-history-title">Chart of Accounts</p>
            <div className="d-flex gap-5 align-items-center">
              <div>
                <CSVLink data={csvData} filename={`Chart-Of-Accounts.csv`}>
                  <img src={CSVImage} className="excel-icon" loading="lazy" />
                </CSVLink>
              </div>
              <div className="post-entry-button" onClick={handleOpen}>
                Post Entry
              </div>
            </div>
          </div>
          <div className="transaction-option-container">
            <div className="transaction-filter-container">
              <div className="filter-left">
                <div>
                  <div>
                    <label for="time" className="selector-titles">
                      Type
                    </label>
                  </div>
                  <div className="transaction-selector">
                    <select
                      name="time"
                      id="time-range"
                      onChange={handleAccountType}
                      value={accountType}
                    >
                      <option value="All">All</option>
                      <option value="Income">Income</option>
                      <option value="Asset">Asset</option>
                      <option value="Liability">Liability</option>
                    </select>
                  </div>
                </div>
              </div>

              <div className="filter-right">
                <div>
                  <label for="currency" className="selector-titles">
                    Currency
                  </label>
                </div>
                <div className="transaction-selector">
                  <select
                    name="currency"
                    id="curreny-selector"
                    onChange={handleCurrencyChange}
                  >
                    <option value="">All</option>
                    <option value="USD">USD</option>
                    <option value="ZAR">ZAR</option>
                    <option value="UXP">UXP</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div>{loadingData ? <>Loading...</> : <AccountingTable />}</div>
        </div>
      </div>
    </>
  );
}

export default Accounting;
